class TableIconReplacer {
  constructor() {
    this.lang = (document.documentElement.lang || '').toLowerCase();
    this.langPrefix = this.getLangPrefix();
    this.replaceIcons();
  }

  getLangPrefix() {
  // 1. HTML lang
  let lang = (document.documentElement.lang || '').toLowerCase();

  // 2. Fallback: body data attribute (if your CMS supports it)
  if (!lang && document.body.dataset.lang) {
    lang = document.body.dataset.lang.toLowerCase();
  }

  // 3. Fallback: check URL (e.g. /en/ or /de/)
  if (!lang) {
    const path = window.location.pathname.toLowerCase();
    if (path.includes('/en')) lang = 'en';
    if (path.includes('/de')) lang = 'de';
  }

  // 4. Normalize
  if (lang.startsWith('en')) return 'E';
  if (lang.startsWith('de')) return 'D';

  // 5. Default (choose what makes sense!)
  return 'E'; // <-- better default than always 'D'
}

  replaceIcons() {
    const tableContainers = document.querySelectorAll('.srl-table-container > table');

    tableContainers.forEach((tableContainer) => {
      const cells = tableContainer.querySelectorAll('td.srl-horizontal-left.ns-horizontal-left');

      cells.forEach((cell) => {
        const span = cell.querySelector('p > span');

        if (span && span.textContent) {
          // Updated regex to support both numeric and non-numeric identifiers (e.g., "bl-01" to "17").
          const regex = new RegExp(`(?:${this.langPrefix})-WEB-Goal-([a-zA-Z0-9-]+)\\.png`, 'g');
          const matches = [];
          let match;

          while ((match = regex.exec(span.textContent)) !== null) {
            matches.push(match);
          }

          if (matches.length > 0) {
            cell.innerHTML = '';

            const imgContainer = document.createElement('div');
            imgContainer.classList.add('img-container');

            matches.forEach((match) => {
              const iconIdentifier = match[1];
              const iconFileName = `${this.langPrefix}-WEB-Goal-${iconIdentifier}.min.svg`;
              const img = document.createElement('img');

              if (document.body.classList.contains('pdf')) {
                img.src = 'https://nswow-ld.nswow.ch/designs/lukb-ld/25.0.27/svg/' + iconFileName;
              } else {
                img.src = '../svg/' + iconFileName;
              }

              img.classList.add('img-sdg');
              imgContainer.appendChild(img);
            });

            cell.appendChild(imgContainer);
          }
        }
      });
    });
  }




}

export default TableIconReplacer;


